// extracted by mini-css-extract-plugin
module.exports = {"Filters":"MasterDataTable_Filters__1SzCi","HeaderItem":"MasterDataTable_HeaderItem__3Dfiy","Header":"MasterDataTable_Header__1KyJ0"};